import { Component } from "@angular/core";
import { ICellRendererAngularComp } from "ag-grid-angular";
import { ICellRendererParams } from "ag-grid-community";

@Component({
    selector: "app-status-cell-renderer",
    template: `
    <span
      class="tmwf-status-text"
      [style.color]="textColor"
    >
      {{ displayValue }}
    </span>
  `,
    styles: [
        `
           .tmwf-status-text {
             font-size: 13px;
             font-weight: 500;
             font-family: "Poppins", sans-serif;
             white-space: nowrap;
           }
         `,
    ],
    standalone: false
})
export class StatusCellRendererComponent implements ICellRendererAngularComp {
  params!: ICellRendererParams;
  displayValue = "";
  textColor = "";

  private statusStyles: Record<string, { text: string; label: string }> = {
    // Kanban-column id keys (top-level row data)
    planned: { text: "#1363df", label: "Open" },
    "in-progress": { text: "#F97316", label: "In-Progress" },
    done: { text: "#22c55e", label: "Completed" },
    cancelled: { text: "#ef4444", label: "Cancelled" },
    // Raw API status_name keys (detail-grid valueGetter output, lowercased)
    open: { text: "#1363df", label: "Open" },
    "in progress": { text: "#F97316", label: "In Progress" },
    inprogress: { text: "#F97316", label: "In Progress" },
    closed: { text: "#22c55e", label: "Closed" },
    complete: { text: "#22c55e", label: "Complete" },
    completed: { text: "#22c55e", label: "Completed" },
    canceled: { text: "#ef4444", label: "Cancelled" },
  };

  agInit(params: ICellRendererParams): void {
    this.params = params;
    const val = ((params.value as string) || "").toLowerCase();
    const style = this.statusStyles[val] || {
      text: "#6b7280",
      label: val,
    };
    this.textColor = style.text;
    this.displayValue = style.label || this.formatLabel(val);
  }

  refresh(): boolean {
    return false;
  }

  private formatLabel(val: string): string {
    return val
      .split("-")
      .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
      .join(" ");
  }
}
